import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { Navbar } from './Navbar';

export function AppLayout() {
  // Set background image on mount (same as Vue version)
  useEffect(() => {
    document.body.style.backgroundImage = "url('/Content/Customize/img/bg4-4.jpg')";
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundSize = 'cover';

    return () => {
      document.body.style.backgroundImage = '';
      document.body.style.backgroundRepeat = '';
      document.body.style.backgroundSize = '';
    };
  }, []);

  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
}
